/**
 * An error message displayed in a dialog.
 */
(function($) {

	var MSG_RESET_MS = 5000;

	var msgShowing = false;
	var lastMsgCloseTimestampMs = null;

	var defaultOptions = {
			title: 'System Error',
			message: '#backend-error-msg',
			buttons: {
				'Reload Page': function(){ window.location.reload();  }
			},
			dialogClass: 'important-dialog'
	};

	$.backendErrorMsg = function(options){
		// Only show one error message at a time
		if(msgShowing) return;

		// Only show if haven't shown recently
		if(lastMsgCloseTimestampMs){
			var nowMs = (new Date()).getTime();
			if(nowMs - lastMsgCloseTimestampMs < MSG_RESET_MS) return;
		}

		// Merge options with defaults
		options = $.extend({}, defaultOptions, options);

		var content = $(options.message);

		// Technical Information
		if(options.technicalInfo){
			content.find('#legacy-function-call-error').show();
			content.find('#legacy-function-call-error-message').text(options.technicalInfo);
		}else{
			content.find('#legacy-function-call-error').hide();
		}

		if(options.sentryId) {

            var errorCode = options.sentryId;
            if(/_+/.test(errorCode)) {
                var chunked = errorCode.split('_');
                if(typeof chunked[1] === 'string') {
                    errorCode = chunked[1];
                }
            }

			if(typeof Raven !== 'undefined') {
                // Raven.captureMessage('JS Info for ' + errorCode, { level: 'info' });
			}

			content.find('#sentry-error-code').show();
			content.find('#error-message-sentry-error-code').text(options.sentryId);

			if(typeof ravenFeedback === 'boolean' && ravenFeedback && typeof ravenInstalled === 'boolean' && ravenInstalled) {
				content.find('#error-message-sentry-error-code-feedback').show();
				content.find('#error-message-sentry-error-code-feedback').on('click', function(){


                    Raven.showReportDialog({
                        eventId: errorCode
                    })
				});
			}
			else {
                content.find('#error-message-sentry-error-code-feedback').remove();
			}

		}
		else {
            content.find('#sentry-error-code').hide();
		}

		// On close dialog allow another to open
		content.bind('dialogclose', function(){
			lastMsgCloseTimestampMs = (new Date()).getTime();
			msgShowing = false;
		});
		msgShowing = true;

		// Display dialog
		content.dialog({
			modal: true,
			title: options.title,
			buttons: options.buttons,
			dialogClass: options.dialogClass,
			events: options.events,
			zIndex: 10000
		});
	};

})(jQuery);


